import classNames from 'classnames';
import { CSSProperties, FC, MouseEventHandler, useEffect, useState } from 'react';
import styles from './style.module.scss';

interface ButtonProps {
  onClick?: MouseEventHandler;
  className?: string;
  type?: 'default' | 'primary' | 'dashed';
  style?: CSSProperties;
  children?: React.ReactNode;
  disabled?: boolean;
  loading?: boolean;
}

const SelfButton: FC<ButtonProps> = ({
  children,
  onClick,
  className,
  type = 'default',
  style = {},
  disabled,
  loading,
}) => {
  const [innerDisabled, setInnerDisabled] = useState(false);
  useEffect(() => setInnerDisabled(disabled ?? false), [disabled]);

  return (
    <button
      onClick={(e) => !loading && onClick?.(e)}
      className={classNames([styles.button, styles[type], className, { [styles.disabled]: innerDisabled }])}
      style={style}
      disabled={innerDisabled}
    >
      {children}
    </button>
  );
};
export default SelfButton;
